@let rev = revision();
@if (rev) {
  <div [formGroup]="form()">
    <section formGroupName="gaeldendeRevision">
      <div class="detail-section-header">Synkronisering</div>

      <app-detail-row [editMode]="editMode()" label="Synkroniserings status">
        {{ rev.synkroniseringStatus }}
        <ng-template #editor>
          <p-select
            [options]="synkroniseringStatusOptions"
            class="w-[178px]"
            formControlName="synkroniseringStatus"
            optionLabel="text"
            optionValue="value"
            appendTo="body" />
        </ng-template>
      </app-detail-row>

      <app-detail-row [editMode]="editMode()" label="Synkroniserings tidspunkt">
        {{ rev.synkroniseringTidspunkt | date: 'dd-MM-yyyy HH:mm' }}
      </app-detail-row>

      <app-detail-row [editMode]="editMode()" label="Sendt til ITC">
        {{ rev.sendtTilItc | date: 'dd-MM-yyyy HH:mm' }}
      </app-detail-row>

      <app-detail-row [editMode]="editMode()" label="Sendt til PFA">
        {{ rev.sendtTilPfa | date: 'dd-MM-yyyy HH:mm' }}
      </app-detail-row>
    </section>
  </div>
}
